import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { IngredientDeleteCard } from './components/IngredientDeleteCard';
import { IngredientDetailsCard } from './components/IngredientDetailsCard';

export function IngredientDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const ingredientQueryResults = useQuery({
        queryKey: ['ingredient', id],
        queryFn: () => Api.Core.Ingredient.getIngredient(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={ingredientQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <IngredientDetailsCard ingredient={data} />

                            {!data?.standardDrinkIngredients?.length &&
                                !data?.customDrinkIngredients?.length && (
                                    <Can I="delete" a="Ingredient">
                                        <IngredientDeleteCard
                                            ingredient={data}
                                        />
                                    </Can>
                                )}
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
